export const IS_CATEGORIES_FETCHING = 'IS_CATEGORIES_FETCHING';
export const CATEGORIES_FETCHING_ERROR = 'CATEGORIES_FETCHING_ERROR';
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';

export const IS_SOURCES_FETCHING = 'IS_SOURCES_FETCHING';
export const SOURCES_FETCHING_ERROR = 'SOURCES_FETCHING_ERROR';
export const GET_ALL_SOURCES = 'GET_ALL_SOURCES';



// WEBPACK FOOTER //
// ./src/redux_related/categories/actions.js